export default {
    works(state) {
        return state.works;   
    },
    hasWorks(state) {
        return state.works && state.works.length > 0
    }
}